import script from "./ChartBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartBox.vue?vue&type=script&setup=true&lang=js"

import "./ChartBox.vue?vue&type=style&index=0&id=c6db14c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6db14c8"]])

export default __exports__